import { useEffect, useState } from "react";
import authProvider from "../../../authProvider";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../../contexts/UserContext";
import { useGlobalContext } from "../../../contexts/GlobalContext";

const UserLogout = () => {
  const navigate = useNavigate();
  const [loading, setloading] = useState(true);
  const { setUserData } = useUserContext();
  const { setIsAuth } = useGlobalContext();
  useEffect(() => {
    setloading(true);
    authProvider
      .logout()
      .then(() => {
        setUserData(null);
        setIsAuth(false);
        navigate("/user/login");
      })
      .catch(() => {
        navigate("/");
      })
      .finally(() => {
        setloading(false);
      });
    // eslint-disable-next-line
  }, []);

  return loading ? <div>Logging out...</div> : null;
};

export const LogoutButton = () => {
  const { setIsAuth } = useGlobalContext();
  const { setUserData } = useUserContext();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);

  const handleLogout = () => {
    setloading(true);
    authProvider
      .logout()
      .then(() => {
        setUserData(null);
        setIsAuth(false);
        navigate("/user/login");
      })
      .catch(() => {
        navigate("/");
      })
      .finally(() => {
        setloading(false);
      });
  };

  return <button className="btn btn-secondary" onClick={handleLogout}>Log{loading ? "ing" : ""}out</button>;
};

export default UserLogout;
